import { useTranslation } from "react-i18next";
import { Input } from "antd";
import { OffsiteCampaignContextType } from "context/OffsiteCampaignProvider";
import RetailFormInfo from "components/Form/RetailFormInfo";
import RetailFormInput from "components/Form/RetailFormInput";
import RetailFormRow from "components/Form/RetailFormRow";
import cc from "classcat";
import cm from "./style.module.scss";

interface OffsiteDailyBudgetProps {
  formFields: OffsiteCampaignContextType["formFields"];
  handleFormFieldsChange: (
    key: keyof OffsiteCampaignContextType["formFields"],
    value: string
  ) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  currencySymbol: string;
}

const OffsiteDailyBudget = ({
  formFields,
  handleFormFieldsChange,
  handleKeyDown,
  currencySymbol,
}: OffsiteDailyBudgetProps) => {
  const { t } = useTranslation();

  return (
    <RetailFormRow className="form-row">
      <RetailFormInfo
        column={{
          number: "2",
          title: t("components.offsiteCampaignForm.firstStep.budget"),
          text: t("components.offsiteCampaignForm.firstStep.budgetText"),
        }}
      />

      <RetailFormInput
        isFocused={formFields.budget !== ""}
        label={t("components.offsiteCampaignForm.firstStep.budgetLabel")}
        className={cc([
          "floating inside show-message",
          formFields.budget === "" ? cm.hidePrefix : "",
        ])}
        name="daily_budget"
        rules={[
          {
            required: true,
            message: t("components.offsiteCampaignForm.firstStep.budgetError"),
          },
        ]}
      >
        <Input
          className="number-input floating"
          prefix={currencySymbol}
          onChange={(e) => handleFormFieldsChange("budget", e.target.value)}
          value={formFields.budget !== "" ? formFields.budget : ""}
          onKeyDownCapture={handleKeyDown}
        />
      </RetailFormInput>
    </RetailFormRow>
  );
};

export default OffsiteDailyBudget;
